export default __webpack_public_path__ + "static/Wallop-Bold-45d88694a7d490a00c0fe8f873fe6f02.woff2";